import { render, staticRenderFns } from "./ApproveImportRequest.vue?vue&type=template&id=f517b686"
import script from "./ApproveImportRequest.vue?vue&type=script&lang=js"
export * from "./ApproveImportRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports